import { ONBOARDING_ENABLED_PATHS } from '../constants/onboarding-enabled-paths';

export function isOnboardingEnabledPath(pathname: string): boolean {
  return ONBOARDING_ENABLED_PATHS.some((prefix) => pathname.startsWith(prefix));
}
